export function locations() {
  let
    body = $("body, html"),
    createMap = function (map) {
      let position = {
          lat: map.data('lat') * 1,
          lng: map.data('lng') * 1
        },
        curMmap = new google.maps.Map(map[0], {
          zoom: 15,
          scrollwheel: false,
          scaleControl: false,
          //draggable: !((typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)),
          draggable: true,
          zoomControl: true,
          disableDoubleClickZoom: true,
          panControl: false,
          mapTypeControl: false,
          streetViewControl: false,
          overviewMapControl: false,
          fullscreenControl: false,
          center: position
        });

      new google.maps.Marker({
        position: position,
        map: curMmap,
        icon: {
          url: map.data('marker-url'),
          scaledSize: new google.maps.Size(37, 45.5),
        }
      });

      map.addClass('init');
    };

  window.initializeMap = function () {
    $('.locations.main').on('click', "h6, .h6", function () {
      let
        $this = $(this),
        parent = $this.closest('li'),
        description = parent.find('> .hidden-info');

      if (parent.hasClass('active')) {
        parent.removeClass('active');
        description.slideUp(300);
      } else {
        parent.siblings().removeClass('active').find('> .hidden-info').slideUp(300);
        parent.addClass('active');
        description.find('> .address-item .map-block:not(.init)').each(function () {
          createMap($(this));
        });
        description.slideDown(300, function () {
          body.animate({
            scrollTop: parseInt(parent.offset().top)
          }, 300);
        });
      }
    });
  };
}



// WEBPACK FOOTER //
// ./assets/js/modules/locations.js